import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AbstractDetailsComponent } from '../../shared/abstract-details.component';
import { AdSchedule, AdScheduleMidrollIntervalUnit } from './../../../interfaces/adschedule';
import { AdScheduleDetailsMetadataComponent } from './adschedule-details-metadata.component';
import { PublicationService } from 'app/services/publication.service';
import { SapiEntity } from 'app/services/sapi.service';
import { Publication } from 'app/interfaces/publication';
import { Observable } from 'rxjs';

@Component({
	selector: 'adschedule-details',
	templateUrl: './adschedule-details.component.html',
	styleUrls: ['./adschedule-details.component.scss']
})

export class AdScheduleDetailsComponent extends AbstractDetailsComponent implements OnInit {

	@ViewChild('formRef', { static: true }) form: NgForm;
	@ViewChild(AdScheduleDetailsMetadataComponent, { static: true }) metadataComponent: AdScheduleDetailsMetadataComponent;

	entity: AdSchedule;
	baseUrl = '';
	previewUrl = '';
	previewClipLength = '';

	constructor(
		protected route: ActivatedRoute,
		protected location: Location,
		private publicationService: PublicationService
	) {

		super(route, location);
		this.entityConfiguration = {
			name: 'adschedule',
			entityType: 'AdSchedule',
			parentPath: '/adservices/adschedules',
			basePath: '/adservices/adschedule/',
			versioned: true,
			showVersionMetadata: true,
			versionMetadataToSave: {
				bbcomment: ''
			},
			defaults: {
				status: 'published',
				title: '',
				preroll: {
					skippable: false,
					minimumContentLength: 0,
					items: []
				},
				midroll: {
					skippable: false,
					useSceneAlignment: false,
					minimumContentLength: 0,
					interval: 25,
					intervalUnit: AdScheduleMidrollIntervalUnit.percent,
					items: []
				},
				postroll: {
					skippable: false,
					minimumContentLength: 0,
					items: []
				}
			}
		};
	}

	ngOnInit() {
		super.ngOnInit();

		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication && publication.baseurl) {
				this.baseUrl = publication.baseurl;
			}
		}));
		this.previewUrl = this.getPreviewUrl();
	}

	getPreviewUrl() {
		let baseUrl = this.baseUrl.replace('http://', 'https://');
		if (baseUrl.indexOf('//') === 0) {
			baseUrl = baseUrl.replace('//', 'https://');
		}
		const vastUrl = baseUrl + '/ad-scheduling/document/vmap/1.0?scheduleId=';
		this.previewClipLength = encodeURIComponent('&clipLength=51');
		return ('https://support.bluebillywig.com/vast-inspector#!/vast_type=vast_url/position=vmap/rendering=html5/hide_settings=off/hide_log=off/vast_url='
		+ encodeURIComponent(vastUrl));
	}

	load(id: string): Observable<SapiEntity> {
		const loadObservable = super.load(id);
		loadObservable.subscribe((entity: AdSchedule) => {
			if (entity) {
				this.metadataComponent.setAssignedPlayouts(entity.playoutCodes || []);
			}
		});

		return loadObservable;
	}

	save(force?: boolean): Observable<any> {
		const saveSubject = super.save(force, null, false);

		saveSubject.subscribe((response) => {
			if (response) {
				this.metadataComponent.updateExcludeTargetedPlayoutsFilterSet(response.playoutCodes || []);
			}
		});

		return saveSubject;
	}
}
